import { Loader } from '@googlemaps/js-api-loader'

const mapsLoader = {
  // The loader instance does not have an API to reinitialize with new configurations.
  // Therefore, this abstraction will initialize once for the mean time until an update
  // from Google is provided. Ref:https://github.com/googlemaps/js-api-loader/issues/100
  initialize: async function (key, libraries = ['places'], region = 'GH') {
    // FIXME: But depends on fix of the above issue
    if (this.instance) {
      return
    }

    this.instance?.reset()

    this.instance = new Loader({
      apiKey: key,
      libraries,
      region,
    })

    await this.instance.load()
  },
  instance: null,
}

export default mapsLoader
